export const payload = {
  receiveMutation: 'RECEIVE_BUDGETS',
  receivingMutation: 'RECEIVING_BUDGETS',
  receiveMetadataMutation: 'RECEIVE_BUDGET_METADATA',
  receiveFailureMutation: 'RECEIVE_BUDGET_FAILURE',
  savingMutation: 'SAVING_BUDGET',
  saveFailureMutation: 'SAVING_BUDGET_FAILURE',
  incrementMutation: 'INCREMENT_BUDGET_COUNT',
  updatingMutation: 'UPDATING_BUDGET',
  updateFailureMutation: 'UPDATING_BUDGET_FAILURE',
  deleteMutation: 'DELETE_BUDGET',
  deletingMutation: 'DELETING_BUDGET',
  deleteFailureMutation: 'DELETING_BUDGET_FAILURE',
  resetMetaMutation: 'RESET_BUDGET_META',
  clearMutation: 'CLEAR_BUDGET_STATE',
  moduleName: 'budget',
  endpoint: 'budgets',
  searchableFields: ['code', 'name', 'description'],
  importEndpoint: 'import-budgetlines'
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Budgets/actionPayload.js